import React from "react";
import BottomNav from "@/components/BottomNav";
import TermsGate from "@/components/TermsGate";

export default function AppShell({ children, showNav = true }) {
  return (
    <div className="min-h-screen bg-[#D8C3A5] text-[#1F2A44]">
      <TermsGate />
      <main className={`max-w-lg mx-auto ${showNav ? "pb-24" : ""}`}>{children}</main>
      {showNav && <BottomNav />}
    </div>
  );
}
